import request from '@/utils/request'


// 历史数据筛选采集器列表查询
export function historyCollectorQuery(data) {
  return request({
    url: '/db/collector/history-collector-query',
    method: 'post',
    data
  })
}

export function collectDetailHistoryController(data){
  return request({
    url: '/db/collect-detail-history/history-query',
    method: 'post',
    data
  })
}
